import { jsx as _jsx } from "react/jsx-runtime";
import { AemConfigurationContextWrapper } from '@as-react/common-components';
export const WrapWithAemConfigurationContext = (BaseComponent, { aemConfigurationValue }) => function AemConfigurationWrapper(props) {
    return (_jsx(AemConfigurationContextWrapper, { value: aemConfigurationValue, children: _jsx(BaseComponent, { ...props }) }));
};
